import { Navigate } from "react-router-dom";
import { useCompany } from "../companies/CompanyContext";

// Schuetzt den Admin-Bereich: nur echte Superadmins (nicht Subadmins).
export default function RequireSuperadmin({ children }) {
  const { isRealSuperadmin, loadingCompanies } = useCompany();

  if (loadingCompanies) {
    return null;
  }
  if (!isRealSuperadmin) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
